import { useCallback } from 'react';
import { useEnvironment, useHttp } from '@publicisgroupe/p-os-components';
import {
  getHelpSectionFromConfigApi,
  getHelpSectionFromSharepointApi,
} from 'components/HelpSection/helpers';
import { SharepointEntities } from 'utils/enums';

const transformData = (data: any) => ({
  title: data.title || data.Title,
  module: data.module || data.Modul?.Value,
  questionText: data.questionText || data.QuestionText,
  answerText: data.answerText || data.AnswerText,
  pageURL: data.pageURL || data.PageURL,
});

export const useFAQPageData = () => {
  const http = useHttp();
  const env = useEnvironment();

  return useCallback(
    async (useConfigModule: boolean) => {
      const responseFaqData = useConfigModule
        ? await getHelpSectionFromConfigApi(http, 'HelpSectionConfig')
        : await getHelpSectionFromSharepointApi(env, SharepointEntities.HelpSection);

      if (!responseFaqData || responseFaqData.length === 0) return;

      return responseFaqData.map(transformData);
    },
    [http, env]
  );
};
